import * as React from 'react';
import { compose, setDisplayName, withHandlers } from 'recompose';
import { Select } from 'ui/shared/Select';

export type OwnProps = {
    id: string;
    locations: ReadonlyArray<string>;
    value: string | null;
    onChange: (l: string) => void;
    style?: React.CSSProperties;
    disabled?: boolean;
};

const RawPtzLocationPicker = ({
    id,
    locations,
    value,
    disabled,
    handleChange,
    style,
}: OwnProps & RecomposeProps) =>
    <Select
        id={ id }
        style={ style }
        value={ value || '' }
        onChange={ handleChange }
        disabled={ disabled }
    >
        { locations.map(l =>
            <option
                key={ l }
                value={ l }
            >
                { l }
            </option>
        ) }
    </Select>
;

type RecomposeProps = {
    handleChange: React.ChangeEventHandler<HTMLSelectElement>;
};

export const PtzLocationPicker = compose<OwnProps & RecomposeProps, OwnProps>(
    setDisplayName('PtzLocationPicker'),
    withHandlers({
        handleChange: ({ onChange }: OwnProps) => (e: React.ChangeEvent<HTMLSelectElement>) => {
            const location = e.currentTarget.value;
            onChange(location);
        },
    }),
)(RawPtzLocationPicker);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/line/PtzLocationPicker.tsx